module.exports = __webpack_public_path__ + "static/media/variety-fresh-tasty-vegetables-dark.84730850.jpg";